import React from 'react';

const WebScraping = () => {
  return (
    <div style={{ fontFamily: 'Arial, Helvetica, sans-serif', margin: '2% 5% 5% 5%' }}>
      <h1>1. Web Scraping</h1>
      <div className='table-container'>
        <table id='Table' style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '12px 8px', textAlign: 'left', backgroundColor: '#0c3678', color: 'white' }}>Leadsheet Name</th>
              <th style={{ border: '1px solid #ddd', padding: '12px 8px', textAlign: 'left', backgroundColor: '#0c3678', color: 'white' }}>Job Status</th>
              <th style={{ border: '1px solid #ddd', padding: '12px 8px', textAlign: 'left', backgroundColor: '#0c3678', color: 'white' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: '#f2f2f2' }}>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Example Leadsheet 1</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Completed</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                <button>View Details</button>
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Example Leadsheet 2</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>In Progress</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                <button>Cancel Job</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WebScraping;